<template>
  <sky-charts
    ref="chart"
    :queryCondition="condition"
    :config="chartConfig"
    legendPosition="bottom"
    :showTitle="false"
    :showShadow="false"
    :chartData="data"
    :extend="extend"
  >
    <div
      slot="header"
      class="header"
    >
      <div class="title">{{tabName}}{{selectName}}<span v-if="tabName!='设备'">TOP10</span></div>
      <div class="select">
        <el-select
          v-model="selectVal"
          placeholder="点击量"
          size="mini"
          @change="change"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
  </sky-charts>
</template>

<script>
import mixins from './ga_mixins'
import { googleOptionPie } from '@/common/dictionary.js'
import filters from '@/mixins/filters.js'
export default {
  name: 'advertising-series',
  mixins: [mixins],
  components: {},
  data() {
    let that = this
    return {
      selectVal: 'IMPRESSIONS',
      options: googleOptionPie,
      selectName: '展示占比',
      selectTitle: '展示次数',
      selectRmb: '',
      tabName: '',
      tabItem: '',
      extend: {
        tooltip: {
          trigger: 'item',
          formatter(val) {
            return `${val.name} <br /> ${
              that.selectName
              }：${filters.filters.percent(val.percent / 100)} <br /> ${
              that.selectTitle
            }：${that.selectRmb}${filters.filters.thousands(val.value)}`
          }
        },
        legend: {
          bottom: 30,
          formatter(val) {
            var cArr = val.match(/[^\x00-\x80]/g)
            if (cArr) {
              if (cArr.length > 7 || val.length > 10) {
                val = val.slice(0, 6) + '...'
              }
            } else {
              if (val.length > 16) {
                val = val.slice(0, 13) + '...'
              }
            }
            var arr = [`{a|${val}}`].join('\n')
            return arr
          },
          textStyle: {
            rich: {
              a: {
                width: 90,
                overflow: 'hidden',
                lineHeight: 10
              }
            }
          }
        }
      },
      chartConfig: {
        height: '400px',
        type: 'vePie',
        columns: [],
        rows: [],
        chartSettings: {
          radius: 80,
          offsetY: '40%'
        }
      },
      data: []
    }
  },
  watch: {
    condition: {
      handler(val) {
        this.data = val.data
        this.tabName = val.tabName
        this.tabItem = val.tabItem
        this.chartConfig.columns = ['name', this.columnSwitch(this.selectVal)]
        if (val.extend) this.extend = { ...this.extend, ...val.extend }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 改变排序字段
    change(val) {
      this.selectVal = val
      this.switch(val)
      this.chartConfig.columns = ['name', this.selectVal]
      this.$emit('googlereportspie', val)
    },
    switch (val) {
      var name = ''
      switch (val) {
        case 'IMPRESSIONS':
          this.selectName = '展示占比'
          this.selectTitle = '展示次数'
          this.selectRmb = ''
          break
        case 'CLICKS':
          this.selectName = '点击占比'
          this.selectTitle = '点击次数'
          this.selectRmb = ''
          break
        case 'COST':
          this.selectName = '消耗占比'
          this.selectTitle = '消耗'
          this.selectRmb = '￥'
          break
      }
      return name
    },
    columnSwitch (val) {
      switch (val) {
        case 'IMPRESSIONS':
          return 'impressions'
        case 'CLICKS':
          return 'clicks'
        case 'COST':
          return 'exchangeRateCost'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #000;
  .el-select {
    width: 100px;
    margin: 0 10px;
  }
}
</style>
